import { arrayMax, arrayMin, range } from "../../utils/array"
import { SharedFieldsService } from "../service"
import { Years } from "./types"
import { viewState } from "./viewState"

export function setupYears(svc: SharedFieldsService) {

    const years = svc.holding.CropYears.map(y => y.YearId).concat(svc.cropping.map(c => c.yearId))

    const { first: defFirst, last: defLast } = viewState.defaultYears || { first: 0, last: 9999 }

    const min = arrayMin(years, y => y)
    const max = arrayMax(years, y => y)

    const current = svc.yearId

    const firstYears = range(1 + current - min).map(y => current - y).sort((a, b) => b - a)
    const lastYears = range(1 + max - current).map(y => current + y).sort((a, b) => a - b)

    const r = {
        first: (defFirst >= min) && (defFirst <= current) ? defFirst : Math.max(current - 2, min),
        last: (defLast <= max) && (defLast >= current) ? defLast : max
    }


    return {
        current: svc.yearId,
        range: r,
        firstYears,
        lastYears
    }

}

export function changeYearRange(current: Years, year: number, setFirst: boolean) {

    const { first, last } = current

    const range = setFirst
        ? { first: year, last: Math.max(last, year) }
        : { first: Math.min(first, year), last: year }

    viewState.defaultYears = range

    return range

}

export function getDefaultScrollPosition(year: { start: Date, end: Date }, getDatePosition: (date: Date) => number) {

    const p1 = getDatePosition(year.start)
    const p2 = getDatePosition(year.end)

    const position = p1 + ((p2 - p1) / 2);

    return position

}
